import logo_arc from '../../../assets/images/logo-arc.png';
import logo_copp from '../../../assets/images/logo-copp.svg';
import styled from 'styled-components'
import { LoggedIn } from './LoggedIn';
import { NavLink } from 'react-router';

export const Wrapper = styled.div`
padding-top: 4rem;
padding-bottom: 6rem;
padding-left: 2rem;
padding-right: 2rem;
background-color: var(--accent2);

display: grid;
grid-template-columns: 1fr;
grid-gap: 1rem;
max-width: 1600px;

.left-container {
  padding-right: 1rem;
}
.right-container {
  padding-left: 0rem;
}

.links-and-resources {
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 600px;
}

@media (min-width: 992px) {
  grid-template-columns: 1fr 1fr;

  .left-container {
    padding-right: 5rem;
  }
  .right-container {
    padding-left: 5rem;
  }
  .links-and-resources {
    max-width: 100%;
  }

}
`

export const Footer = () => {

  return (
    <Wrapper>
      <div className='left-container'>
        <div>We pay our respects to the traditional<br />owners, the Bunurong and Boon Wurrung<br />People of the Kulin Nations.</div>
        <hr/>
        <div>
          Portplay is brought to you by <b>ARC</b><br />
          in partnership with the <b>City of Port Phillip</b>
        </div>
      </div>
      <div className='right-container'>
        <h3>Links & Resources</h3>
        <div className='links-and-resources'>
          <h4><NavLink to='/'>Home Page</NavLink></h4>
          <h4><NavLink to='vendorfaqs'>For Vendors</NavLink></h4>
          <h4><NavLink to='whatson'>What's On</NavLink></h4>
          <h4><NavLink to='faqs'>FAQ</NavLink></h4>
          {/* <h4><NavLink to='schedule'>Schedule</NavLink></h4> */}
          <h4><NavLink to='conduct'>Conduct</NavLink></h4>
        </div>
      </div>
      
      <div className='left-container left-align-container'>
        <div style={{padding: '1rem'}}><img src={logo_arc} alt='australian role-play community' width='135px' height='90px' /></div>
        <div style={{padding: '1rem'}}><img src={logo_copp} alt='council of port phillip' width='72px' height='90px' /></div>
        
      </div>

      <div className='right-container'>
        <LoggedIn />
        {/* <div><a href="https://events.humanitix.com/port-play" className='btn-pink'>buy tickets</a></div> */}
        <div><span className='btn-pink' style={{cursor: 'default', opacity: 0.8}}>Tickets on Sale Soon</span></div>
      </div>

    </Wrapper>
  )
}